var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.sesiAdmins)?_c('div',[_c('sesi-area-join-campaign')],1):_vm._e(),(_vm.companyAdmin)?_c('div',[_c('company-area-join-campaign')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }